import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-sage-200 last:border-0" data-id="element-1">
      <button className="flex items-center justify-between w-full py-6 text-left transition-colors hover:text-sage-600 focus:outline-none" onClick={onClick} data-id="element-2">
        <span className="text-xl font-semibold font-serif text-sage-900" data-id="element-3">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-shrink-0 ml-4 text-sage-400" data-id="element-4">
          <ChevronDown className="w-6 h-6" data-id="element-5" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-6">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-7">
            <div className="pb-6 text-lg text-sage-700 leading-relaxed" data-id="element-8">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
interface AccordionProps {
  items: {
    question: string;
    answer: string;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto bg-white rounded-2xl shadow-sm p-8 md:p-10 border border-sage-100" data-id="element-9">
      {items.map((item, index) => <AccordionItem key={index} question={item.question} answer={item.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-10" />)}
    </div>;
}